<template>
    <div>
        <app-entrega
            :entrega="entrega"
            :entregasServicos="obterEntregasServicos()"
            :movimentosServicos="obterMovimentosServicos()"
            @obterEntregaAtualizada="obterEntregaAtualizada()"
        >
            <template slot="contratacaoFooter">
                <app-btn-voltar></app-btn-voltar>
            </template>
        </app-entrega>
    </div>
</template>

<script>
import EntregasServicos from './EntregasServicos'
import Entrega from '@/app/credenciados/componentes/entregas/Entrega'
import MovimentosServicos from './../movimentos/MovimentosServicos'

export default {
    data() {
        return {
            entrega: {}
        }
    },

    methods: {
        obterEntrega() {
            this.$store.dispatch('addRequest')
            EntregasServicos.obterPorIdPorGestor(
                this.$route.params.entregaId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.entrega = response.data
                    } else {
                        this.$toast.error(
                            'Erro ao obter entrega!!!',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterEntregasServicos() {
            return EntregasServicos
        },

        obterMovimentosServicos() {
            return MovimentosServicos
        },

        obterEntregaAtualizada() {
            this.obterEntrega()
            if (this.$route.name == 'Gestores_Entregas_Detalhar') {
                this.$store.dispatch('setRecarregar', true)
            } else {
                this.$emit('obterAtualizacao')
            }
        }
    },

    created() {
        this.obterEntrega()
    },

    components: {
        AppEntrega: Entrega
    }
}
</script>
